import script from "./CustomStatusBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomStatusBadge.vue?vue&type=script&setup=true&lang=ts"

import "./CustomStatusBadge.vue?vue&type=style&index=0&id=3f0d4290&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f0d4290"]])

export default __exports__